class BasketEventListener {
    constructor() {
        this.listeners();

        document.dispatchEvent(new Event('update-product-counts'));

        // const page = document.querySelector('[data-basket-page]:not([data-without-partners="true"])');
        // if (page) {
        //     const partnerOpener = document.querySelector('a[data-partner-opener]');
        //     const partnerForm = document.querySelector('[data-partner-form]');
        //     const inputs = partnerForm ? partnerForm.querySelectorAll('input[type="radio"]') : [];
        //
        //     if (partnerOpener && inputs.length > 1) {
        //         let href = window.location.href;
        //         href += window.location.search ? '&' : '?';
        //         href += 'withoutPartners=true';
        //         window.history.replaceState({}, '', href);
        //         setTimeout(() => {
        //             partnerOpener.dispatchEvent(new Event('click'));
        //         }, 500);
        //     }
        // }
    }

    listeners() {
        this.addSuccess();
        this.updateProductCounts();
        // this.returnDeletedProduct();
        this.deleteProduct();
    }

    deleteProduct() {
        document.addEventListener('delete-basket-product', (e) => {
            const basketItem = e.detail.basketItem;
            const parent = basketItem.parentElement;
            const returnLink = parent.querySelector('[data-return-product-container]');
            returnLink.classList.add('_visible');
        });
    }

    updateProductCounts() {
        document.addEventListener('update-product-counts', (e) => {
            $.ajax({
                type: 'GET',
                url: `${window.location.origin}/basket/counts`,
            }).done((response) => {
                if (response.success) {
                    const elements = document.querySelectorAll(`[data-product-count-in-cart]`);
                    elements.forEach((element) => {
                        const id = parseInt(element.dataset.productCountInCart);
                        const info = response.product_counts.find((item) => item.id === id);
                        if (info) {
                            element.innerHTML = info.count;
                            element.classList.add('_visible');
                        } else {
                            element.classList.remove('_visible');
                            element.innerHTML = '';
                        }
                    });
                }
            });
        });
    }

    addSuccess() {
        document.addEventListener('add-basket-success', (e) => {
            const element = document.querySelector('[data-add-basket-success]');
            if (!element) {
                return;
            }

            element.classList.add('_show');
            element.dataset.ticks = parseInt(element.dataset.ticks) + 1;

            setTimeout(() => {
                const currentTicks = parseInt(element.dataset.ticks) - 1;
                element.dataset.ticks = currentTicks;
                console.log('currentTicks', currentTicks)
                if (currentTicks <= 0) {
                    element.classList.remove('_show');
                }
            }, 2000);
        });
    }
}

document.addEventListener('DOMContentLoaded', (e) => new BasketEventListener());